module.exports = {"apiKey":"AIzaSyDYGu8enSh6x7tnDJAVvj6QkBJNJu1ADs0","authDomain":"hajime-tools.firebaseapp.com","databaseURL":"https://hajime-tools.firebaseio.com","projectId":"hajime-tools","storageBucket":"hajime-tools.appspot.com","messagingSenderId":861806036049}


//////////////////
// WEBPACK FOOTER
// ./src/.firebaseEnv.json
// module id = 40
// module chunks = 1